<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row>
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="7">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_title"
                                @search="searchSupplierContract"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="5">
                            <gofix-form-dropdown
                                label="Property Type" 
                                :filterable="false"
                                :clearable="false"
                                :options="property_types" 
                                v-model="property_type"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row>
                        <b-col md="8">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Division" 
                                :filterable="false" 
                                :options="locations" 
                                v-model="location" 
                                @search="searchLocation" 
                                vLabel="name" 
                                show-icon-required>
                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                    <span class="text-hidden-one-row">{{ option.location_path || '-' }}</span>
                                </template>
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <span v-b-tooltip.hover.top :title="option.location_path" v-html="$options.filters.highlightNode(option.location_path, key_search_property)"></span>
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4" class="text-center pt-15">
                            <gofix-button label="Export PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:weightage" slot-scope="row">
                {{ `${row.item.weightage}%` }}
            </template>
            <template slot="gofix_table:actual_weightage" slot-scope="row">
                {{ `${row.item.actual_weightage}%` }}
            </template>
        </gofix-table>
    </gofix-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'other-sources',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-other-sources',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'other_sources_description',
                        label: 'Other Sources Description',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'weightage',
                        label: 'Weightage',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'actual_weightage',
                        label: 'Actual Weightage',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: {
                location: null,
                scontract: null
            },
            activeExportBtn: false
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract(null, true);
        },
        "supplier_contract": function(val) {
            this.location = null;
            this.searchLocation('', () => {})
        },
        "location": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "property_type": function(val) {
            this.location = null;
            this.searchLocation('', () => {})
            this.$refs.gofixTable.reloadTableItems();
        },
        "month": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "year": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
    },
    created() {
        this.getInitData()
        this.getSupplierContract(null, true);
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();

            if ( !this.supplier_contract || !this.location ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }
            
            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_id = this.location.location_id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'other source'

            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);

                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null, is_set_default = false) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.location = null;
                this.locations = [];

                this.supplier_contracts = response.data.data.contracts

                if(is_set_default) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer.scontract) {
                clearTimeout(this.timer.scontract);
                this.timer.scontract = null;
            }
            this.timer.scontract = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        searchLocation(search, loading) {
            this.loading = true
            this.locations = []
            if (this.timer.location) {
                clearTimeout(this.timer.location);
                this.timer.location = null;
            }
            this.timer.location = setTimeout(() => {
                this.key_search_property = search;
                const property_root_id = this.supplier_contract ? this.supplier_contract.property_root_id : null
                const contract_id = this.supplier_contract ? this.supplier_contract.id : null

                // this.$store.dispatch('PropertyController/getSearchProperties', {
                //     keyword: search,
                //     property_root_id: property_root_id,
                //     limit: 100,
                //     is_active: true,
                //     property_type: this.property_type,
                //     contract_id: contract_id,
                // })
                
                this.$store.dispatch('PerformanceAssesmentSettingsController/getItems', {
                    keyword: search,
                    property_root_id: property_root_id,
                    type_setting: 'pa_contract_sum_setting',
                    filter: {
                        contract_id: contract_id,
                        property_type: this.property_type,
                        location_name: ''
                    },
                    sortColumn: 'location_name',
                    sortDirection: 'asc',
                })
                .then(response => {
                    this.locations = response.items
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            }, 500);
        },
        async dataPAReport() {
            if ( !this.supplier_contract ) {
                return false;
            }
            if ( !this.location ) {
                return false;
            }

            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'other source'
            };

            await this.$store.dispatch("PAConservancyController/getPAReport", getParam)
            .then(response => {
                this.tableItems = response.items
            })
            .catch(err => { })
        },
        async exportReport() {
            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'other source',
                is_download_pdf: true,
            };

            await this.$store.dispatch("PAConservancyController/exportPAReport", getParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'other-sources-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        }
    }
}
</script>